import React from 'react';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Quote from 'marketing-website/components/modules/Quote';
import CabifyIcon from 'marketing-website/components/icons/CabifyIcon';

const quote = {
  content:
    '“If we added up all the time it would take to discuss new features and designs without using Marvel, it would definitely add weeks to the design process.”',
  caption: 'Rene Galindo, Lead Product Designer at Cabify — ',
  linkText: 'Read Case Study',
  linkUrl: '/case-studies/cabify',
};

export default function HubBlock() {
  return (
    <div className="bg-snow">
      <Spacing size="xl" type="padding" position="topBottom">
        <PageWrap size="m">
          <Spacing type="padding" size="xl" position="leftRight">
            <Spacing type="padding" size="l" position="topBottom">
              <Quote {...quote} icon={CabifyIcon} iconColor="purple" />
            </Spacing>
          </Spacing>
        </PageWrap>
      </Spacing>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/collaboration/CaseStudyQuoteBlock.js